import Highcharts from 'highcharts';
import { getSMSizes } from "./data";

/**
 * @param {string} id
 */
export default function chartGuards(id) {
    if (!document.getElementById(id)) return;

    const cityData = getSMSizes().sort((a, b) => b.guardsPer100k - a.guardsPer100k)

    const categories = cityData.map(item => item.city);
    const guardsData = cityData.map(item => item['Etaty: liczba strażników']);
    const guardsPer100kData = cityData.map(item => item.guardsPer100k)

    const avgPer100k = guardsPer100kData.reduce((a, b) => a + b, 0) / guardsPer100kData.length

    const barColor = '#3498db';
    const belowAvgColor = '#547a94';

    const guardsPer100kDataWithColor = cityData.map(item => ({
        y: item.guardsPer100k,
        color: item.guardsPer100k >= avgPer100k ? barColor : belowAvgColor
    }));

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Liczba strażników miejskich i wskaźnik na 100k mieszkańców' },
        xAxis: {
            categories: categories,
            type: 'category',
            title: { text: null },
            labels: { style: { fontSize: '16px' } }
        },
        yAxis: [{
            title: {
                text: null,
            },
            labels: {
                style: { color: '#999' }
            },
            opposite: true
        }, {
            min: 0,
            title: {
                text: null,
            },
            labels: {
                style: { color: barColor }
            },
            plotLines: [{
                value: avgPer100k,
                dashStyle: 'ShortDot',
                width: 3,
                zIndex: 5,
                label: {
                    text: `Średnia: ${avgPer100k.toFixed(0)}`,
                    align: 'right',
                    verticalAlign: 'bottom',
                    style: { color: barColor, fontWeight: 'bold' }
                }
            }]
        }],
        legend: {
            enabled: true,
            verticalAlign: 'top',
            align: 'center'
        },
        tooltip: {
            shared: true,
            formatter: function () {
                let tooltip = ``;
                if (this.points) {
                    this.points.forEach(point => {
                        if (point.series.name === 'Liczba strażników') {
                            tooltip += `${point.series.name}: <b>${point.y}</b><br/>`;
                        } else {
                            tooltip += `${point.series.name}: <b>${point.y}</b><br/>`;
                        }
                    });
                }
                return tooltip;
            }
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    formatter: function () {
                        if (this.series.name === 'Liczba strażników') {
                            return Math.round(this.y || 0);
                        } else {
                            return this.y;
                        }
                    }
                }
            },
            series: {
                grouping: false,
                borderWidth: 0
            }
        },
        credits: { enabled: false },
        series: [{
            name: 'Liczba strażników', // Ta seria będzie teraz rysowana pierwsza (pod spodem)
            type: 'bar',
            yAxis: 0,
            data: guardsData,
            color: '#999',
            pointPlacement: -0.2
        }, {
            name: 'Strażnicy na 100k mieszkańców', // Ta seria przykryje poprzednią w miejscu przecięcia
            type: 'bar',
            yAxis: 1,
            data: guardsPer100kDataWithColor,
            color: barColor,
            id: 'main',
            dataSorting: {
                enabled: true,
                matchByName: true
            },
        }]
    });
}
